import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "../styles/HeroSection.css";
import "../styles/LogoAnimation.css";

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="hero-section">
      <div className="hero-left">
        {/* Burbujas fuera del círculo, flotan sobre toda la columna */}
        <div className="hero-bubbles">
          <div className="bubble x1"></div>
          <div className="bubble x2"></div>
          <div className="bubble x3"></div>
          <div className="bubble x4"></div>
          <div className="bubble x5"></div>
          <div className="bubble x6"></div>
          <div className="bubble x7"></div>
          <div className="bubble x8"></div>
          <div className="bubble x9"></div>
          <div className="bubble x10"></div>
        </div>

        {/* Círculo del logo sin burbujas adentro */}
        <div className="logo-container">
          <div className="bubble-background"></div>
          <div className="logo-image">
            <img src="media/logo-abis-lp.png" alt="Logo ABIS La Paz" />
          </div>
        </div>
      </div>

      <div className="hero-right">
        <Typography variant="h1" className="hero-titulo" component="h1">
          ABIS La Paz
        </Typography>

        <Typography variant="h2" className="hero-subtitulo" component="h2">
          Liderando la Ingeniería Sanitaria y Ambiental para un futuro sostenible.
        </Typography>

        <Typography variant="body1" className="hero-descripcion" component="p">
          En ABIS La Paz trabajamos por el fortalecimiento técnico y profesional
          del sector agua, saneamiento y ambiente, con una mirada de largo plazo
          orientada al bienestar de la población y al desarrollo sostenible.
        </Typography>

        <div className="hero-actions">
          <Button
            variant="contained"
            color="primary"
            className="hero-btn-primary"
            onClick={() => navigate("/noticias")}
          >
            Últimas Noticias
          </Button>

          <Button
            variant="outlined"
            color="primary"
            className="hero-btn-secondary"
            onClick={() => navigate("/nosotros")}
          >
            Quiénes Somos
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
